import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from "@angular/common/http";
import { catchError, Observable, of, throwError } from "rxjs";
import { Router } from "@angular/router";
import { LoginService } from "../service/login/login.service";
import { environment } from "../../environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private loginService: LoginService, private router: Router){

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.loginService.getToken()
    let authReq = req

    if(req.url.includes('refresh-user')){
      authReq = req.clone({
        setHeaders: {
          JWT: environment.jwt,
          ApiKey: environment.apikey
        }
      })  
    }else if(req.url.includes('api.wheel-size')){
      
    }else{
      if(token){
        if(!this.loginService.validarTokenValido()){
          this.loginService.LogOutSession(); 
          this.router.navigate(['/LogIn']); 
          throw new Error("Token ha Expirado");
        }else{
          authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
              ApiKey: environment.apikey
            }
          })  
        }
      }else{
        authReq = req.clone({
          setHeaders: {
            ApiKey: environment.apikey
          }
        }) 
      }
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => { 
        if (error.status === 401) { 
          this.loginService.LogOutSession(); // Limpiar el token 
          if (this.router.url !== '/LogIn'){
            this.router.navigate(['/LogIn']).then(() => {
              window.location.reload();
            });
          }
          throw new Error("Token ha Expirado");
        }else{
          return of(null);
        } 
        return of(null);
      }) );
  }

  
}